import { fetchAuthSession } from '@aws-amplify/auth';

const UpdateProfilePicture = async (username: string, imageData: string) => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/user/profilepic/update`; 
  const payload = {
    "username": username,
    "imageData": imageData
  }

  try {
    const { tokens } = await fetchAuthSession();
    const authToken = tokens?.accessToken?.toString();

    if (!authToken) {
      throw new Error('Authentication token not available');
    }

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': authToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      const data = await response.json();
      console.log('Profile picture updated successfully:', data);
      return data;
    } else {
      const errorText = await response.text();
      console.error('Failed to update profile picture:', response.status, errorText);
      throw new Error(`Failed to update profile picture: ${response.status} ${response.statusText}`);
    }
  } catch (err) {
    console.error('Error updating profile picture:', err);
    throw err; // Re-throw the error so it can be caught by the calling function
  }
};

export default UpdateProfilePicture;
